module.exports = __webpack_public_path__ + "static/image/main/card/image-11.ver2_0_2.png?db15ed25";